const state = {
    user: null,
    userRole: '',
    userDepartment: '',
    userSchool: ''
  }
  
  const mutations = {
    SET_USER(state, user) {
      state.user = user
    },
    SET_USER_ROLE(state, role) {
      state.userRole = role
    },
    SET_USER_DEPARTMENT(state, department) {
      state.userDepartment = department
    },
    SET_USER_SCHOOL(state, school) {
      state.userSchool = school
    }
  }
  
  const actions = {
    setUser({ commit }, user) {
      commit('SET_USER', user)
    },
    setUserRole({ commit }, role) {
      commit('SET_USER_ROLE', role)
    },
    setUserDepartment({ commit }, department) {
      commit('SET_USER_DEPARTMENT', department)
    },
    setUserSchool({ commit }, school) {
      commit('SET_USER_SCHOOL', school)
    },
    initializeUserData({ dispatch }, { role, department, school }) {
      dispatch('setUserRole', role)
      dispatch('setUserDepartment', department)
      dispatch('setUserSchool', school)
    }
  }
  
  const getters = {
    getUser: state => state.user,
    getUserRole: state => state.userRole,
    getUserDepartment: state => state.userDepartment,
    getUserSchool: state => state.userSchool
  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
  }
  
  